import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';

import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { baseTheme } from '../../../theme';
import { GroupModal } from '../group-modal';
import { createGroupAction, updateListConfig, clearGroups } from '../../../store/groups/actions';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(0),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(0),
      marginBottom: theme.spacing(1),
      borderBottom: 'solid 1px',
      borderColor: theme.palette.primary.main,
    },
    createButton: {
      color: theme.palette.background.default,
      backgroundColor: theme.palette.primary.main,
    },
    alignRight: {
      textAlign: 'right',
    },
  }),
);

export function GroupToolBar(props: any) {
  const classes = useStyles(baseTheme);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dispatch = useDispatch();
  const currUser = useSelector((state: any) => state.auth.currUser);
  const listConfig = useSelector((state: any) => state.groups.listConfig);
  const handleCreateGroup = () => {
    setIsOpen(true);
  };

  const handleCallBack = (group: any) => {
    if (group) {
      createGroupAction(currUser, group, dispatch);
      clearGroups(dispatch);
    }

    setIsOpen(false);
  };

  const handleTextSearch = (prop: any) => (event: any) => {
    const updatedValues = {
      ...listConfig,
      [prop]: searchTerm.toLowerCase(),
    };

    updateListConfig(updatedValues, dispatch);
    clearGroups(dispatch);
  };

  const handleFormChange = (prop: any) => (event: any) => {
    const updatedValues = {
      ...listConfig,
      [prop]: event.target.value,
    };

    if (prop !== 'search') {
      updateListConfig({
        ...updatedValues,
        search: searchTerm,
      }, dispatch);
      clearGroups(dispatch);
    } else {
      setSearchTerm(event.target.value);
    }
  };

  return (
    <Grid item container xs={12} className={classes.root}>
      <Grid item container xs={6} spacing={1}>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <TextField
              size="small"
              label="Search"
              value={searchTerm}
              variant="outlined"
              onChange={handleFormChange('search')}
              InputProps={{
                endAdornment:
                  (<InputAdornment position="end">
                    <IconButton
                      aria-label="search posts"
                      edge="end"
                      onClick={handleTextSearch('search')}>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>),
              }} />
          </FormControl>
        </Grid>

        <Grid item xs={3}>
          <FormControl variant="outlined" fullWidth size="small">
            <InputLabel id="filter-posts">Filter</InputLabel>
            <Select
              labelId="filter-posts"
              id="filter-posts"
              value={listConfig.filter}
              label="Filter"
              onChange={handleFormChange('filter')}
            >
              <MenuItem value="all">All Posts</MenuItem>
              <MenuItem value="public">Public Group Posts</MenuItem>
              <MenuItem value="closed">Closed Group Posts</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={3}>
          <FormControl variant="outlined" fullWidth size="small">
            <InputLabel id="sort-posts">Sort</InputLabel>
            <Select
              labelId="sort-posts"
              id="sort-posts"
              value={listConfig.sort}
              label="Sort"
              onChange={handleFormChange('sort')}
            >
              <MenuItem value="name-ascend">Group Name Ascending</MenuItem>
              <MenuItem value="name-descend">Group Name Descending</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid item xs={5}></Grid>
      <Grid item xs={1} className={classes.alignRight}>
        <Button
          variant="contained"
          className={classes.createButton}
          startIcon={<AddIcon />}
          onClick={handleCreateGroup}
        >
          Create Group
        </Button>
      </Grid>

      <GroupModal
        open={isOpen}
        handleCallBack={handleCallBack}
        groupType={'Closed'}
      />
    </Grid>
  );
}
